function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#line-account-box_svg__iwfo8897wa)"
}, React.createElement("path", {
  d: "M19 5v14H5V5h14zm0-2H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 9c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm6 10H6v-1.53c0-2.5 3.97-3.58 6-3.58s6 1.08 6 3.58V18zm-9.69-2h7.38c-.69-.56-2.38-1.12-3.69-1.12s-3.01.56-3.69 1.12z",
  fill: "#F19700"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "line-account-box_svg__iwfo8897wa"
}, React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})));

var SvgLineAccountBox = function SvgLineAccountBox(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cg clip-path='url(%23iwfo8897wa)'%3E %3Cpath d='M19 5v14H5V5h14zm0-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 9c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm6 10H6v-1.53c0-2.5 3.97-3.58 6-3.58s6 1.08 6 3.58V18zm-9.69-2h7.38c-.69-.56-2.38-1.12-3.69-1.12s-3.01.56-3.69 1.12z' fill='%23F19700'/%3E %3C/g%3E %3Cdefs%3E %3CclipPath id='iwfo8897wa'%3E %3Cpath fill='%23fff' d='M0 0h24v24H0z'/%3E %3C/clipPath%3E %3C/defs%3E %3C/svg%3E";
export { SvgLineAccountBox as ReactComponent };